export default {
    state: {
        set: new Set()
    },
    reducers: {
        sync: (state, payload = {}) => Object.assign({}, state, payload)
    }
}
